(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvEntityEmbeddedManyInput', drvEntityEmbeddedManyInput);

    /**
     * @ngdoc directive
     * @name drvEntityEmbeddedManyInput
     * @description Many Embedded Entity input control.
     *
     * @param {array} field - An entity field object which is an array of embedded entities.
     */
    function drvEntityEmbeddedManyInput() {
        return {
            templateUrl: 'app/fieldinput/entity-embedded-many-input.tmpl.html',
            require: 'ngModel',
            scope: {},
            controller: drvEntityEmbeddedManyInputCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                value: '=ngModel',
                entityTemplates: '=',
                fieldTypes: '=',
                field: '=',
                fileAttachmentList: '='
            }
        };
    }

    drvEntityEmbeddedManyInputCtrl.$inject = ['$scope', 'DialogService', 'Entity', 'EntityDialogService', 'EntityFieldImage'];

    function drvEntityEmbeddedManyInputCtrl($scope, DialogService, Entity, EntityDialogService, EntityFieldImage) {
        /* jshint validthis:true */
        var drvCtrl = this;
        drvCtrl.copyEmbeddedEntity = copyEmbeddedEntity;
        drvCtrl.editEmbeddedEntity = editEmbeddedEntity;
        drvCtrl.deleteEmbeddedEntity = deleteEmbeddedEntity;
        Object.defineProperty(drvCtrl, 'entityTemplate', { get: function () { return _.find(drvCtrl.entityTemplates, function (entityTemplate) { return entityTemplate.Id === drvCtrl.field.EntityTemplateId; }); } });
        Object.defineProperty(drvCtrl, 'orderedEmbeddedEntities', { get: getOrderedEmbeddedEntities });

        /**
         * Get the ordered list of embedded entities.
         *
         */
        function getOrderedEmbeddedEntities() {
            var orderedEntities = [];

            if (!_.isNil(drvCtrl.entityTemplate.OrderSetting) && !_.isNil(drvCtrl.entityTemplate.OrderSetting.Default)) {
                var orderOption = _.find(drvCtrl.entityTemplate.OrderSetting.Options, function (option) {
                    return option.Name === drvCtrl.entityTemplate.OrderSetting.Default;
                });

                if (!_.isNil(orderOption)) {
                    var orderFieldList = [];
                    var orderDirectionList = [];

                    angular.forEach(orderOption.Fields, function (field) {
                        if (!_.isNil(field.Name) && field.Name !== '') {
                            orderFieldList.push(field.Name.replace('fields|', ''));
                            orderDirectionList.push(field.Order);
                        }
                    });

                    orderedEntities = _.sortByOrder(drvCtrl.value, orderFieldList, orderDirectionList);
                }
            } else {
                orderedEntities = drvCtrl.value;
            }

            if (!angular.equals(orderedEntities, getOrderedEmbeddedEntities.entities)) {
                getOrderedEmbeddedEntities.entities = orderedEntities;
            }

            return getOrderedEmbeddedEntities.entities;
        }

        /**
         * For the embedded entity that the user clicked on, present a dialog with its details as a 'copy'.
         * If the user clicks 'OK' on the dialog, the copy of the embedded entity will be added.
         */
        function copyEmbeddedEntity(entity) {
            // Convert to Entity 2.0
            var convertedEntity = Entity.convertEntity1toEntity2(
                {
                    EntityTemplateId: drvCtrl.field.EntityTemplateId,
                    Fields: entity
                },
                drvCtrl.entityTemplates);

            // Remove all images
            var iter = convertedEntity.getFieldIterator();
            while (iter.next()) {
                if (iter.currentEntityField instanceof EntityFieldImage) {
                    iter.currentEntityField.value = null;
                }
            }

            // Fetch dependencies for dialog
            var enitityTemplate = angular.copy(drvCtrl.entityTemplate);
            var fieldTypes = angular.copy(drvCtrl.fieldTypes);
            var entityTemplates = angular.copy(drvCtrl.entityTemplates);

            // Show embedded entity dialog for user input
            var dialogScope = $scope.$new(true);
            dialogScope.title = 'Copy ' + enitityTemplate.Name;
            DialogService.show({
                locals: {
                    entityFields: convertedEntity.toValueObject().Fields,
                    entityTemplate: enitityTemplate,
                    fieldTypes: fieldTypes,
                    entityTemplates: entityTemplates,
                    fileAttachmentList: drvCtrl.fileAttachmentList
                },
                scope: dialogScope,
                controller: 'EntityEmbeddedEditCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/entity-embedded-edit.tmpl.html'
            }).then(copyDialogOk);

            // User clicked OK on dialog, add the embedded entity copy
            function copyDialogOk(entityField, fileAttachmentList) {
                drvCtrl.value.push(entityField);
            }
        }

        /**
         * For the embedded entity that the user clicked on, present a dialog to edit the entity.
         * If the user clicks 'OK' on the dialog, the embedded entity will be updated.
         */
        function editEmbeddedEntity(entity) {
            var enitityTemplate = angular.copy(drvCtrl.entityTemplate);
            var entityField = angular.copy(entity);
            var fieldTypes = angular.copy(drvCtrl.fieldTypes);
            var entityTemplates = angular.copy(drvCtrl.entityTemplates);

            DialogService.show({
                locals: { entityFields: entityField, entityTemplate: enitityTemplate, fieldTypes: fieldTypes, entityTemplates: entityTemplates, fileAttachmentList: drvCtrl.fileAttachmentList },
                controller: 'EntityEmbeddedEditCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/entity-embedded-edit.tmpl.html'
            })
            .then(editFieldOk);

            function editFieldOk(entityField, fileAttachmentList) {
                // Field is empty and has been initialised as a string. It needs to be an array.
                if (angular.isUndefined(drvCtrl.value) || drvCtrl.value === null || drvCtrl.value === '') {
                    drvCtrl.value = [];
                }
                if (entity == 'new') {
                    drvCtrl.value.push(entityField);
                }
                else {
                    var entityIndex = drvCtrl.value.indexOf(entity);

                    drvCtrl.value[entityIndex] = entityField;
                }
            }
        }

        /**
         * For the embedded entity that the user clicked on, it will be removed after the user confirms.
         */
        function deleteEmbeddedEntity(entity) {
            var entityIndex = drvCtrl.value.indexOf(entity);

            EntityDialogService.confirmDeleteEntities(drvCtrl.value[entityIndex], drvCtrl.entityTemplate)
                .then(function () {
                    drvCtrl.value.splice(entityIndex, 1);
                });
        }
    }
})();